import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { LoginButton } from "../buttons/login-button";

interface HeroSectionProps {
  heroRef: React.RefObject<HTMLElement>;
  handleSignUp: (e?: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  heroRef,
  handleSignUp,
}) => {
  const { isAuthenticated } = useAuth0();

  return (
    <section className="hero-section" ref={heroRef}>
      <div className="hero-banner">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              AI made by teachers, <br />
              <span className="hero-headline-nowrap">for teachers</span>
            </h1>
            <p className="hero-subtitle">
              Custom-made lesson plans and resources for Aussie primary
              classrooms, with outcomes aligned to{" "}
              <span className="hero-subtitle-emphasis">
                NSW, VIC and Australian curriculum codes
              </span>
              .
            </p>
            <div className="hero-cta">
              {!isAuthenticated ? (
                <>
                  <div className="hero-cta-buttons">
                    <button onClick={handleSignUp} className="hero-cta-button">
                      Try for free
                    </button>
                    <LoginButton />
                  </div>
                </>
              ) : (
                <a href="/dashboard" className="hero-cta-button">
                  Go to Dashboard
                </a>
              )}
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-trust-badges">
              <div className="hero-australia-badge">
                <img
                  src="/images/australian_made_badge.png"
                  alt="Australian made and owned"
                  className="australian-made-badge-image"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Decorative fan of real generated documents, clipped by the hero's
            bottom edge so they read as samples sliding into view. */}
        <div className="hero-samples" aria-hidden="true">
          <img
            src="/images/sample-unit-of-work.jpg"
            alt=""
            className="hero-sample hero-sample-unit-of-work"
          />
          <img
            src="/images/sample-worksheet.jpg"
            alt=""
            className="hero-sample hero-sample-worksheet"
          />
          <img
            src="/images/sample-slideshow.jpg"
            alt=""
            className="hero-sample hero-sample-slideshow"
          />
        </div>
      </div>
    </section>
  );
};
